import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Chip from 'components/common/Chip';

import pxToRem from 'styles/pxToRem';
import hexToRgb from 'styles/hexToRgb';

const styles = theme => ({
  root: {
    marginLeft: -6,
    marginRight: -6,
  },
  chipGroup: {
    display: 'inline-flex',
    whiteSpace: 'nowrap',
    verticalAlign: 'top',
    margin: 6,
    '& $chip': {
      margin: 0,
    },
  },
  chipSeparator: {
    fontSize: pxToRem(13),
    display: 'inline-flex',
    marginLeft: 6,
    marginRight: 6,
    lineHeight: '30px',
  },
  chip: {
    margin: 6,
    verticalAlign: 'top',
  },
  chipMain: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.primary[500])}, 0.15)`,
  },
});

const InventoryHCPCCodes = ({ className, classes, ...otherProps }) => (
  <div className={classNames(classes.root, className)}>
    {otherProps['HCPC Codes'].map((item, index) => (
      item.length === 1 ? (
        <Chip
          className={classNames(classes.chip, {
            [classes.chipMain]: index === 0,
          })}
          size="md"
          label={item[0]}
          key={item[0]}
        />
      ) : (
        <div
          className={classes.chipGroup}
          key={item.join('-')}
        >
          {item.map((nestedItem, nestedIndex) => (
            <Fragment key={nestedItem}>
              {nestedIndex !== 0 &&
                <Typography
                  className={classes.chipSeparator}
                  color="secondary"
                >
                  or
                </Typography>
              }
              <Chip
                className={classNames(classes.chip, {
                  [classes.chipMain]: index === 0 && nestedIndex === 0,
                })}
                size="md"
                borderColor="primary"
                label={nestedItem}
              />
            </Fragment>
          ))}
        </div>
      )
    ))}
  </div>
);

InventoryHCPCCodes.propTypes = {
  'HCPC Codes': PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.string),
  ).isRequired,
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    chipGroup: PropTypes.string.isRequired,
    chipSeparator: PropTypes.string.isRequired,
    chip: PropTypes.string.isRequired,
    chipMain: PropTypes.string.isRequired,
  }).isRequired,
};

InventoryHCPCCodes.defaultProps = {
  className: '',
};

export default withStyles(styles)(InventoryHCPCCodes);



// WEBPACK FOOTER //
// ./src/components/inventory/InventoryHCPCCodes/InventoryHCPCCodes.js